import type { ConsignmentFinanceSummary } from './consignment-payments';

export const ACCOUNTING_ROLES = {
  MARKETPLACE_CLEARING: 'Marketplace clearing',
  CONSIGNOR_PAYABLE: 'Consignor payable (G/L control)',
  COMMISSION_INCOME: 'Commission income',
  FIXED_FEE_INCOME: 'Fixed consignment fee income',
  UNSOLD_FEE_INCOME: 'Reviewed unsold consignment fee income',
  BANK_TRANSFER: 'Bank transfer clearing',
  CHECK: 'Check clearing',
  PAYPAL: 'PayPal clearing',
  CASH: 'Cash clearing',
  OTHER: 'Other payment clearing',
} as const;
export type AccountingRole = keyof typeof ACCOUNTING_ROLES;
export interface ConsignmentAccountingMapping {
  company: string;
  vendor: string;
  accounts: Partial<Record<AccountingRole, string>>;
}
export interface ConsignmentAccountingRequest {
  operation: 'PREVIEW_STATEMENT_ACCOUNTING';
  consignorId: string;
  statementId: string;
  mapping?: ConsignmentAccountingMapping;
}
export interface ConsignmentAccountingEntry {
  role: AccountingRole;
  account?: string;
  debitMinor: number;
  creditMinor: number;
}
export interface ConsignmentAccountingSource {
  sourceId: string;
  kind: 'STATEMENT_APPROVED' | 'ADJUSTMENT_APPROVED' | 'PAYMENT_RECORDED' | 'PAYMENT_VOIDED';
  version: number;
  date: string;
  paymentReference?: string;
  entries: ConsignmentAccountingEntry[];
  debitMinor: number;
  creditMinor: number;
}
export interface ConsignmentAccountingPreview {
  schemaVersion: 1;
  mode: 'REVIEW_ONLY';
  generatedAt: string;
  statementId: string;
  consignorId: string;
  consignorName: string;
  currency: 'USD';
  statementVersion: number;
  finance: ConsignmentFinanceSummary;
  mapping: ConsignmentAccountingMapping;
  mappingStatus: 'UNVERIFIED';
  exportStatus: 'NOT_CHECKED';
  sourceFingerprint: string;
  reportFingerprint: string;
  sources: ConsignmentAccountingSource[];
  cards: Array<{
    allocationId: string;
    cardId: string;
    orderId: string;
    lineItemId: string;
    title?: string;
  }>;
  feeCharges?: import('./consignment-charges').ConsignmentFeeChargeLine[];
  totals: { debitMinor: number; creditMinor: number; balanced: boolean };
  issues: string[];
  limitations: string[];
}
